import {
  Box,
  Button,
  Grid,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import { doc, serverTimestamp, Timestamp, updateDoc } from "firebase/firestore";
import { FC, useEffect, useState } from "react";
import { db } from "../../../..";
import { useServerTime } from "../../../../hooks/useServetTime";
import { getProblem4th } from "../../data/prob";
import { mainBg, mainColor } from "../../theme";
import { StagePlayerProps } from "../NazoClusterQuizPlayer";

export const Stage4thPlayer: FC<StagePlayerProps> = (props) => {
  const { room, user, roomId, userId } = props;
  const stage4 = room?.stage4;
  const prob = getProblem4th(stage4?.probNumber ?? 1);

  const playerName = user?.name ?? "";
  const start = stage4?.phase !== "waiting";
  const { serverTime } = useServerTime({
    serverTimeDocId: playerName !== "" ? playerName ?? "player" : "player",
    runTimer: !!room && !!user && start && playerName !== "",
  });
  const countDown = !start
    ? 30
    : stage4?.phase === "finished" ||
      stage4?.phase === "calculated" ||
      stage4?.phase === "explaining"
    ? 0
    : Math.max(
        0,
        (prob?.timeLimit ?? 30) -
          ((serverTime?.getTime() ?? 0) -
            (stage4?.startTime as Timestamp)?.toDate()?.getTime()) /
            1000
      );
  const explained =
    stage4?.phase === "explaining" || stage4?.phase === "calculated";
  const finished =
    stage4?.phase === "finished" ||
    stage4?.phase === "calculated" ||
    stage4?.phase === "explaining";

  const [input, setInput] = useState(
    user.stage4?.[stage4?.probNumber ?? "1"]?.answer ?? ""
  );
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (finished && !submitted) {
      setSubmitted(true);
      // 時間切れ時にsubmitする処理
      // 再アクセスしたときにsubmit済であれば投稿しない
      if (user.stage4?.[stage4?.probNumber ?? "1"]?.answer) {
        return;
      }
      updateDoc(doc(db, "nazoClusterQuiz/" + roomId + "/user/" + userId), {
        ["stage4." + stage4?.probNumber]: {
          answer: input,
          answerTime: serverTimestamp(),
        },
      });
    }
  }, [finished, submitted]);

  useEffect(() => {
    // phase: waiting時に初期化
    setInput(user.stage4?.[stage4?.probNumber ?? "1"]?.answer ?? "");
    if (!start) {
      setSubmitted(false);
    }
  }, [start]);

  const submit = () => {
    if (!roomId) return;
    if (!user) return;
    if (!prob) return;
    if (!start) return;
    if (finished) return;
    if (!serverTime) return;
    if (!input) return;
    if (!userId) return;
    setSubmitted(true);
    updateDoc(doc(db, "nazoClusterQuiz/" + roomId + "/user/" + userId), {
      ["stage4." + stage4?.probNumber]: {
        answer: input,
        answerTime: serverTimestamp(),
      },
    });
  };

  return (
    <Grid container>
      <Grid item xs={4}>
        <div
          style={{
            width: "calc(100% - 4vw)",
            margin: "2vw",
            height: "10vh",
            borderRadius: "4vw",
            backgroundColor: mainBg,
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: "8vw",
              fontWeight: "bold",
            }}
          >
            {prob?.problemNumberText}
          </p>
        </div>
      </Grid>

      <Grid item xs={8}></Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          margin: "2vw 0",
        }}
      >
        <Box sx={{ minWidth: 35 }}>
          <Typography
            variant="body1"
            color="text.primary"
            sx={{
              color: mainColor,
              fontSize: "5vw",
              fontWeight: "bold",
              marginLeft: "2vw",
            }}
          >{`${("0" + Math.floor(countDown / 60)).slice(-2)}:${(
            "0" + Math.floor(countDown % 60)
          ).slice(-2)}`}</Typography>
        </Box>
        <Box sx={{ margin: 2, width: "100%" }}>
          <LinearProgress
            variant="determinate"
            value={(countDown / 30) * 100}
            sx={{
              height: "2vw",
            }}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          color: mainColor,
          fontSize: "2vw",
          fontWeight: "bold",
          textAlign: "center",
          margin: "2vw 0",
        }}
      >
        <p>制限時間{prob?.timeLimit}秒</p>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          color: mainColor,
          fontSize: "2vw",
          fontWeight: "bold",
          textAlign: "center",
          margin: "2vw 0",
        }}
      >
        <p>{prob?.answerMessage}</p>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          color: mainColor,
          fontSize: "2vw",
          fontWeight: "bold",
          textAlign: "center",
          margin: "2vw 0",
        }}
      >
        <Grid container>
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              sx={{
                width: "calc(100% - 4vw)",
                height: "100%",
                margin: "0 2vw",
                bgcolor: "white",
              }}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              disabled={!start || finished || submitted}
            />
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="contained"
              sx={{
                margin: "0 2vw",
                width: "calc(100% - 4vw)",
                height: "100%",
                fontSize: "5vw",
                fontWeight: "bold",
              }}
              disabled={!start || finished || submitted}
              onClick={submit}
            >
              提出
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
